import { Grid2, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AppInput } from '../../Input/AppInput';
import { getValidator } from '../../../Helpers/Constants/validators';

const StyledAppInput = styled(AppInput)(({ theme }) => ({
	'& .MuiOutlinedInput-root': {
		'&.Mui-focused fieldset': {
			borderColor: theme.palette.insurance.primary,
		},
	},
}));

export const CustomInsuranceInput = () => {
	const { t } = useTranslation('common');

	const formValidators = {
		insuranceCompany: getValidator(t, 50, null, { value: true }, 1),
		policyNumber: getValidator(t, 50, null, { value: true }, 1),
	};

	return (
		<Grid2 container spacing={2}>
			<Grid2 size={{ xs: 12, md: 6 }}>
				<StyledAppInput
					name='agencyInsurance.customInsurance.companyName'
					rules={formValidators.insuranceCompany}
					label={t('rentPage.insuranceCompany')}
					autoComplete='off'
					requiredInput
				/>
			</Grid2>
			<Grid2 size={{ xs: 12, md: 6 }}>
				<StyledAppInput
					name='agencyInsurance.customInsurance.number'
					rules={formValidators.policyNumber}
					label={t('rentPage.policyNumber')}
					autoComplete='off'
					requiredInput
				/>
			</Grid2>
		</Grid2>
	);
};
